export default __webpack_public_path__ + "static/media/lastGIF.093fca09.gif";